module.exports = __webpack_public_path__ + "assets/fonts/BarlowCondensed-Regular.560339c4-ps.ttf";